const SET_CAMPAIGNS = "SET_CAMPAIGNS";
const SET_CAMPAIGNS_LINKS = "SET_CAMPAIGNS_LINKS";
const UPDATE_SEG_FILTER_SELECTED_SEGS = "UPDATE_SEG_FILTER_SELECTED_SEGS";
const UPDATE_FILTER = "UPDATE_FILTER";
const SET_FILTERS = "SET_FILTERS";
export { SET_CAMPAIGNS, SET_CAMPAIGNS_LINKS, UPDATE_FILTER, SET_FILTERS };
